<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="tenant">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info" />
          {{ dataId ? '查看' : '新增' }}仓位设置
        </div>
        <div class="fr">
          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
                <tr>
                  <th>
                    <em class="f-red">*</em>
                    仓库名称
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="tenant.itemName" clearable readonly="true">
                      <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog=true"></i>
                    </el-input>
                  </td>
           
                  <th>
                    <em class="f-red">*</em>
                   启用
                  </th>
                  <td>
                    <el-select v-model="tenant.parentId4">
                        <el-option label="禁用" :value="0" />
                        <el-option label="启用" :value="1" />                     
                      </el-select>
                  </td>  
                  </tr>
                <tr>
                  <th>
                    <em class="f-red">*</em>
                    库位编码
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="tenant.serviceTypeName" clearable />
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    库位名称
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="tenant.serviceTypeName" clearable />
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    仓位
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="tenant.serviceTypeName" clearable />
                  </td>
                </tr>
                <tr>
                  <th>创建人</th>
                  <td>{{ tenant.createBy }}</td>
                  <th>创建时间</th>
                  <td>{{ tenant.createDate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
     
        </div>

      </div>
    </el-form>
    <preconditionDialog v-if="showPreconditionDialog" @commitSelectedRow="commitSelectedRow" :visiable.sync="showPreconditionDialog" multi="true"
      />
  </div>
</template>
<script>
  import {
    initVxeTable
  } from '@/const/crud/admin/table';
  import Tinymce from '@/components/Tinymce';
  import request from "@/router/axios";
  import preconditionDialog from './dialog';
  export default {
    name: 'edit',
    props: {
      _dataId: [String, Number]
    },
    components: {
      Tinymce,
      preconditionDialog,
    },
    data() {
      return {
        img_b: "",
        upload_btn: false, // 是否隐藏上传图片按钮
        radio: '1',
        showEdit: false,
        valuetype: 'model',
        textarea: '',
        //  value1: true,
        value2: false,
        value3: true,
        activeName: 'first',
        dialog: {
          one: false,
        },
        lan: 'zh_CN',
        isEdit: false,
        tabIndex: 'first',
        dataId: '',
        // 基本信息
        tenant: {
          status: 0,
          tenantAttachmentDTOs: []
        },
        showPreconditionDialog: false,
      };
    },
    computed: {
      // enabled: {}
    },
    created() {
      if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
      // console.log(this.tenant,"tenant的值");
    },
    mounted() {

      this.getData();
      console.log(this.tenant, "tenant的值");
      console.log(this._dataId, "_dataId的值");
    },
    methods: {
      confirmSaleConfig(rows) {
        if (rows.length > 0) {
          const $grid = this.$refs.configGrid;
          const tableData3 = $grid.getTableData().fullData;
          const map = {};
          tableData.forEach(function (item) {
            map[item.configId] = 1;
          });
          var items = [];
          rows.forEach((row, index) => {
            const item = {
              configId: row.id,
              configName: row.configName
            };
            if (index == 0 && tableData3.length == 0) {
              item.defaults = true;
            }
            if (!map[item.configId]) {
              items.push(item);
            }
          });
          this.product.saleProductConfigDTOs = this.product.saleProductConfigDTOs.concat(items);
        }
      },
      // 上传成功

      // 第一个  表格
      formatter(row, column) {
        return row.address;
      },
      submitUpload() {
        this.$refs.upload.submit()
      },

      getData() {
        if (this.dataId && !isNaN(this.dataId)) {
          this.isEdit = true;
          request({
            url: '/admin/fwpttenant/get',
            method: 'post',
            data: {
              id: this.dataId
            },
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            console.log(response);
            this.tenant = response.data.objx || {};
          })
        } else {
          // this.enabled = true;
        }
      },
      saveData() {
        this.$refs.editForm.validate(valid => {
          if (valid) {
            this.$baseConfirm('您确定要保存吗？').then(() => {
              this.$mask.open()

              var url = HXFW_PREFIX + (this.isEdit ? `/fault/code/update` : `/fault/code/save`);
              this.$http({
                url: url,
                method: `post`,
                data: this.tenant,
                isLoading: true,
                success: res => {
                  this.$message({
                    message: res.content,
                    type: 'success',
                    duration: 500,
                    onClose: t => {
                      if (this.isEdit) {
                        this.$baseReload();
                        this.$mask.close()

                      } else {
                        this.$baseReload({
                          updateParam: {
                            _dataId: res.objx
                          }
                        });
                        this.$mask.close()

                      }
                    }
                  });
                }
              });
            });
          }
        });
      },
      confirmCategory(rows) {
        if (rows.length > 0) {
          let row = rows[0];
          this.tenant.itemCatId = row.id;
          this.tenant.itemCatName = row.categoryName;
          this.tenant.itemCatCode = row.categoryCode;
        }
      },
    },
  };

</script>
<style lang="scss" scoped>
  // 输入框的宽度
  #containt .table-detail tbody tr td .el-input {
    width: 100% !important;
    width: 165px !important;
  }
</style>
